import type { Asset } from '@schibsted-svp/svp-api-types';

export function isAudioContent(asset: Asset | undefined): boolean {
  return (
    asset?.assetType === 'audio' ||
    !!asset?.additional?.metadata?.tts_articleId ||
    asset?.additional?.metadata?.isPodcast === 'true'
  );
}
